// R2 — Couche de branding commune Boomerang Géolocalisation pour tous les exports de rapports.
// PRÉSENTATION UNIQUEMENT : ne recalcule aucune donnée (km/durées/scope/périodes viennent de R1A/B/C).
import logoUrl from "../assets/boomerang_logo.png";
import { htmlEscape, csvSafe } from "./reportAgg";

export const BRAND = {
  name: "Boomerang Géolocalisation",
  orange: "#F5821F",
  teal: "#17A2B8",
  tealRGB: [23, 162, 184],
  orangeRGB: [245, 130, 31],
  slate: [51, 65, 85],
  confidential: "Document généré automatiquement — Confidentiel",
  // V2 — jeton de design commun (miroir de BRAND_PDF backend)
  navyRGB: [15, 23, 42],
  grayRGB: [100, 116, 139],
  grayLightRGB: [148, 163, 184],
  cardBgRGB: [248, 250, 252],
  cardBorderRGB: [226, 232, 240],
  rowAltRGB: [244, 247, 250],
  // Premium — pastille d'icône ronde (teal pâle) + bandeau contact navy + slogan.
  pillBgRGB: [224, 242, 245],
  navyBandRGB: [15, 23, 42],
  bandSubRGB: [203, 213, 228],
  tagline: "Plus loin, ensemble",
  contact: { city: "Ducos, Nouméa — Nouvelle-Calédonie", phone: "+687 777655", email: "contact@boomerang.nc", web: "www.boomerang.nc" },
};

// V2 — icônes vectorielles discrètes (aucune police externe/emoji). Dessinées en teal.
function _pdfKpiIcon(doc, label, cx, cy) {
  const s = String(label).toLowerCase();
  doc.setDrawColor(...BRAND.tealRGB); doc.setFillColor(...BRAND.tealRGB); doc.setLineWidth(0.9);
  if (/(synth|résum|resum)/.test(s)) {                              // histogramme (synthèse)
    doc.setLineWidth(1.4);
    doc.line(cx - 3.5, cy + 3.5, cx - 3.5, cy + 0.5);
    doc.line(cx, cy + 3.5, cx, cy - 2.5);
    doc.line(cx + 3.5, cy + 3.5, cx + 3.5, cy - 4);
  } else if (/(véhicule|vehicule|unité|unite)/.test(s)) {          // voiture
    doc.roundedRect(cx - 5, cy - 2, 10, 4.5, 1, 1, "S");
    doc.line(cx - 3, cy - 2, cx - 1.5, cy - 4); doc.line(cx - 1.5, cy - 4, cx + 2, cy - 4); doc.line(cx + 2, cy - 4, cx + 3.5, cy - 2);
    doc.circle(cx - 3, cy + 2.5, 1, "F"); doc.circle(cx + 3, cy + 2.5, 1, "F");
  } else if (/(distance|km|kilom)/.test(s)) {                       // pin
    doc.circle(cx, cy - 1.5, 3, "S"); doc.circle(cx, cy - 1.5, 1, "F");
    doc.line(cx - 2.2, cy + 0.4, cx, cy + 4); doc.line(cx + 2.2, cy + 0.4, cx, cy + 4);
  } else if (/(temps|mouvement|marche|ralenti|arrêt|arret|min)/.test(s)) {  // horloge
    doc.circle(cx, cy, 4, "S"); doc.line(cx, cy, cx, cy - 2.4); doc.line(cx, cy, cx + 2, cy);
  } else if (/(vitesse|max|km\/h)/.test(s)) {                       // jauge
    doc.circle(cx, cy + 1, 4, "S"); doc.line(cx, cy + 1, cx + 2.4, cy - 1.6);
  } else if (/(carburant|énerg|energ|conso|coût|cout|xpf|litre|kwh)/.test(s)) {  // goutte
    doc.line(cx, cy - 4, cx - 3, cy + 1); doc.line(cx, cy - 4, cx + 3, cy + 1); doc.circle(cx, cy + 1.5, 2.6, "S");
  } else if (/(alerte|excès|exces|épisode|episode)/.test(s)) {      // triangle alerte
    doc.line(cx, cy - 4, cx - 3.6, cy + 2.5); doc.line(cx, cy - 4, cx + 3.6, cy + 2.5); doc.line(cx - 3.6, cy + 2.5, cx + 3.6, cy + 2.5);
    doc.line(cx, cy - 1.5, cx, cy + 0.6);
  } else {                                                          // pastille par défaut
    doc.circle(cx, cy, 2.4, "F");
  }
}

// V2 — arc de marque très pâle, confiné au coin supérieur droit (jamais sur le wordmark), page 1.
function _drawCornerArcs(doc, W) {
  const g = doc.setGState ? doc.GState({ opacity: 0.07 }) : null;
  if (g) doc.setGState(g);
  doc.setDrawColor(...BRAND.tealRGB);
  doc.setLineWidth(6); doc.circle(W, 0, 34, "S");
  doc.setLineWidth(4); doc.circle(W, 0, 22, "S");
  doc.setLineWidth(2.5); doc.circle(W, 0, 12, "S");
  if (doc.setGState) doc.setGState(doc.GState({ opacity: 1 }));
}

// --- Nom de fichier propre : Boomerang_<Client>_<Rapport>_<start>_<end>.<ext> -----------
export function sanitizeFilename(s) {
  return String(s == null ? "" : s)
    .normalize("NFD").replace(/[\u0300-\u036f]/g, "")   // enlève accents
    .replace(/[^A-Za-z0-9._-]+/g, "_").replace(/_+/g, "_").replace(/^_|_$/g, "") || "rapport";
}

export function buildFilename({ client, report, start, end, ext, tz }) {
  const z = tz || "Pacific/Noumea";
  // Date calendaire au fuseau du COMPTE (jamais UTC) : évite un décalage d'un jour avant 11:00 Nouméa.
  const day = (x) => {
    if (!x) return "";
    const d = x instanceof Date ? x : new Date(x);
    if (isNaN(d.getTime())) return "";
    return new Intl.DateTimeFormat("en-CA", { timeZone: z, year: "numeric", month: "2-digit", day: "2-digit" }).format(d);
  };
  const parts = ["Boomerang", sanitizeFilename(client), sanitizeFilename(report), day(start), day(end)].filter(Boolean);
  return `${parts.join("_")}.${ext}`;
}

// --- Période / date de génération -------------------------------------------------------
const _fmt = (dt, tz) => {
  const opt = { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" };
  if (tz) opt.timeZone = tz;
  return dt.toLocaleString("fr-FR", opt).replace(",", "");
};
export function formatPeriod(startD, endD, tz) {
  return `${_fmt(startD, tz)} → ${_fmt(endD, tz)}`;
}
export function formatGeneratedAt(tz) {
  const z = tz || "Pacific/Noumea";
  return `${_fmt(new Date(), z)} — ${z}`;
}

// --- B2 — Métadonnées géographiques Activité (présentation only, aucun recalcul) ---------
// Heure au fuseau SOCIÉTÉ (Pacific/Noumea | Pacific/Tahiti). Jamais d'UTC brut affiché.
// Format court "06:42" ; si le rapport couvre plusieurs jours : "09/09 06:42".
export function fmtClock(isoStr, tz, multiDay) {
  if (!isoStr) return "";
  const d = new Date(isoStr);
  if (isNaN(d.getTime())) return "";
  const z = tz || "Pacific/Noumea";
  const hm = d.toLocaleTimeString("fr-FR", { timeZone: z, hour: "2-digit", minute: "2-digit", hour12: false });
  if (!multiDay) return hm;
  const dm = d.toLocaleDateString("fr-FR", { timeZone: z, day: "2-digit", month: "2-digit" });
  return `${dm} ${hm}`;
}

// "—" si valeur absente (jamais null/undefined/"" affiché).
export function geoText(v) {
  return (v === null || v === undefined || v === "") ? "—" : v;
}

// Props de cellule LIEU (WEB) : troncature visuelle + tooltip contenant la valeur complète.
export function geoCellProps(value) {
  const full = geoText(value);
  return { text: full, title: String(full), className: "inline-block max-w-[180px] truncate align-bottom" };
}

// Arrêts principaux (max 3) formatés pour les exports détaillés — le frontend NE recalcule RIEN :
// il formate seulement heure début, heure fin, durée et lieu déjà fournis par le backend.
// Ex. "09:14–10:02 · 48 min · CLIENT ABC | 12:05–12:48 · 43 min · MAGENTA".
export function formatStops(stops, tz, multiDay) {
  if (!Array.isArray(stops) || !stops.length) return "";
  return stops.slice(0, 3).map((s) => {
    const a = fmtClock(s.start_at, tz, multiDay);
    const b = fmtClock(s.end_at, tz, multiDay);
    const loc = (s.location === null || s.location === undefined) ? "" : String(s.location);
    return `${a}–${b} · ${s.duration_min} min · ${loc}`.trim();
  }).join(" | ");
}

// Durée lisible FR : '18 s', '1 min 18 s', '1 h 05 min'. Présentation seule (aucun recalcul).
export function fmtDuration(s) {
  s = Math.max(0, Math.round(Number(s) || 0));
  const h = Math.floor(s / 3600), m = Math.floor((s % 3600) / 60), sec = s % 60;
  if (h) return `${h} h ${String(m).padStart(2, "0")} min`;
  if (m) return `${m} min ${String(sec).padStart(2, "0")} s`;
  return `${sec} s`;
}

// --- KPI par type de rapport (réutilise les valeurs déjà agrégées, aucun recalcul métier) ---
export function computeKPIs(src, rows) {
  const rowsArr = rows || [];
  const sum = (k) => rowsArr.reduce((a, r) => a + (Number(r[k]) || 0), 0);
  const max = (k) => rowsArr.reduce((a, r) => Math.max(a, Number(r[k]) || 0), 0);
  const avg = (k) => (rowsArr.length ? Math.round(rowsArr.reduce((a, r) => a + (Number(r[k]) || 0), 0) / rowsArr.length) : 0);
  if (src === "activity") return [
    ["Véhicules", rowsArr.length],
    ["Distance totale", `${sum("distance_km").toFixed(1)} km`],
    ["Temps en mouvement", `${sum("moving_min")} min`],
    ["Ralenti", `${sum("idle_min")} min`],
    ["Arrêt", `${sum("stop_min")} min`],
    ["Vitesse max", `${max("max_speed")} km/h`],
    ["Excès de vitesse", sum("speeding_events")],
  ];
  if (src === "eco") return [
    ["Score moyen", avg("score")],
    ["Accélérations brusques", sum("harsh_accels")],
    ["Freinages", sum("harsh_brakes")],
    ["Virages", sum("cornerings")],
    ["Excès", sum("speedings")],
    ["Distance", `${sum("km").toFixed(1)} km`],
  ];
  if (src === "alerts") return [
    ["Alertes totales", sum("count")],
    ["Véhicules concernés", rowsArr.length],
  ];
  if (src === "alertsum") {
    const top = rowsArr.slice().sort((a, b) => (Number(b.count) || 0) - (Number(a.count) || 0))[0];
    return [
      ["Alertes totales", sum("count")],
      ["Type principal", top ? String(top.label || top.type || "—") : "—"],
    ];
  }
  return [];
}

// R4 — cartes KPI du rapport énergie : SOURCE DE VÉRITÉ = résumé backend (jamais recalculé côté front).
export function energyKpisFromSummary(k) {
  const s = k || {};
  const n = (x) => (x === null || x === undefined ? 0 : x);
  return [
    ["Distance totale", `${Number(n(s.distance_km)).toFixed(1)} km`],
    ["Litres CAN", `${Number(n(s.liters_can)).toFixed(2)} L`],
    ["Litres estimés", `${Number(n(s.liters_est)).toFixed(2)} L`],
    ["kWh CAN", `${Number(n(s.kwh_can)).toFixed(2)} kWh`],
    ["kWh estimés", `${Number(n(s.kwh_est)).toFixed(2)} kWh`],
    ["Coût total", `${n(s.cost_xpf)} F`],
    ["Véhicules CAN", n(s.n_can)],
    ["Véhicules estimés", n(s.n_est)],
    ["Véhicules sans donnée", n(s.n_unknown)],
    ["Véhicules coût inconnu", n(s.unknown_cost_count)],
  ];
}

// R5 — cartes KPI du rapport « Visites POI » : SOURCE DE VÉRITÉ = synthèse backend (jamais recalculé côté front).
export function poiVisitsKpiCards(k) {
  const s = k || {};
  const n = (x) => (x === null || x === undefined ? 0 : x);
  return [
    ["POI visités", n(s.n_pois)],
    ["Visites", n(s.n_visits)],
    ["Véhicules", n(s.n_vehicles)],
    ["Présence totale", fmtDuration(n(s.presence_s))],
    ["Arrêt total", fmtDuration(n(s.stopped_s))],
    ["Ralenti total", fmtDuration(n(s.idle_s))],
  ];
}

// R5 — « Sites les plus visités » : PRÉSENTATION SEULE, dérivée de la synthèse POI déjà produite par
// _poi_visits_dataset (aucune lecture Mongo, aucun scan positions, aucun recalcul métier). Classement :
// visites décroissantes, égalité départagée par présence totale décroissante puis poi_id (déterministe).
export function topVisitedPois(pois, limit = 5) {
  return (pois || [])
    .filter((p) => (Number(p.visits) || 0) > 0)
    .slice()
    .sort((a, b) => (b.visits - a.visits)
      || ((b.presence_s || 0) - (a.presence_s || 0))
      || String(a.poi_id).localeCompare(String(b.poi_id)))
    .slice(0, limit);
}

// --- Footer commun (parts textuelles, testable) ----------------------------------------
export function footerParts({ client, generatedAt }) {
  return [BRAND.name, client || "—", generatedAt || "", BRAND.confidential];
}

// --- Export HTML de marque (échappement R1C conservé intégralement) ---------------------
export function brandedHtml({ title, client, period, generatedAt, kpis, header, body, numericIdx, extraTable }) {
  const e = htmlEscape;
  const numSet = new Set(numericIdx || []);
  const kpiBlock = (kpis && kpis.length)
    ? `<section class="kpi" aria-label="Résumé">${kpis.map((k) =>
        `<div class="kpi-card"><span class="kpi-label">${e(k[0])}</span><span class="kpi-val">${e(k[1])}</span></div>`).join("")}</section>`
    : "";
  const thead = `<tr>${header.map((h, i) => `<th class="${numSet.has(i) ? "num" : ""}">${e(h)}</th>`).join("")}</tr>`;
  // Section complémentaire optionnelle (ex. « Détail des excès de vitesse ») — échappement R1C conservé.
  const extraBlock = (() => {
    if (!extraTable || !extraTable.header) return "";
    const xnum = new Set(extraTable.numericIdx || []);
    const xhead = `<tr>${extraTable.header.map((h, i) => `<th class="${xnum.has(i) ? "num" : ""}">${e(h)}</th>`).join("")}</tr>`;
    const xbody = (extraTable.body && extraTable.body.length)
      ? extraTable.body.map((r) => `<tr>${r.map((c, i) => `<td class="${xnum.has(i) ? "num" : ""}">${e(c)}</td>`).join("")}</tr>`).join("")
      : `<tr><td colspan="${extraTable.header.length}" class="empty">Aucun épisode sur la période.</td></tr>`;
    return `<h2 class="section">${e(extraTable.title || "Détail")}</h2><table><thead>${xhead}</thead><tbody>${xbody}</tbody></table>`;
  })();
  const tbody = body.length
    ? body.map((r) => `<tr>${r.map((c, i) => `<td class="${numSet.has(i) ? "num" : ""}">${e(c)}</td>`).join("")}</tr>`).join("")
    : `<tr><td colspan="${header.length}" class="empty">Aucune donnée sur la période.</td></tr>`;
  return `<!doctype html><html lang="fr"><head><meta charset="utf-8"><meta name="viewport" content="width=device-width,initial-scale=1">
<title>${e(title)} — ${e(client)}</title>
<style>
:root{--teal:${BRAND.teal};--orange:${BRAND.orange}}
*{box-sizing:border-box}
body{font-family:Arial,Helvetica,sans-serif;color:#1e293b;background:#fff;margin:0;padding:32px}
.report{max-width:1040px;margin:0 auto}
header.brand{display:flex;align-items:flex-start;justify-content:space-between;gap:24px;border-bottom:3px solid var(--orange);padding-bottom:16px;margin-bottom:22px}
header.brand .id{display:flex;flex-direction:column;gap:2px}
header.brand img{height:46px;object-fit:contain}
.wordmark{text-align:right}
.wordmark .n{font-size:14px;font-weight:800;color:var(--teal)}
.wordmark .s{font-size:10px;color:#94a3b8;margin-top:2px}
h1.title{font-size:24px;font-weight:800;margin:14px 0 6px;color:#0f172a;letter-spacing:-.01em}
h2.section{font-size:15px;font-weight:800;margin:26px 0 8px;color:var(--teal);border-bottom:2px solid var(--orange);padding-bottom:5px}
.client{font-size:14px;font-weight:700;color:var(--teal);margin:0}
.period{font-size:12px;color:#475569;margin:6px 0 0}
.genat{font-size:11px;color:#94a3b8;margin:3px 0 0}
.kpi{display:grid;grid-template-columns:repeat(4,1fr);gap:12px;margin:0 0 24px}
.kpi-card{border:1px solid #e2e8f0;border-left:3px solid var(--teal);border-radius:8px;padding:10px 14px;background:#f8fafc}
.kpi-label{display:block;font-size:10px;text-transform:uppercase;letter-spacing:.05em;color:#64748b}
.kpi-val{display:block;font-size:19px;font-weight:800;color:#0f172a;margin-top:3px}
table{border-collapse:collapse;width:100%;margin-top:4px;font-variant-numeric:tabular-nums}
th,td{border:1px solid #e2e8f0;padding:9px 12px;text-align:left;font-size:12.5px}
th{background:var(--teal);color:#fff;font-weight:700;border-color:#fff}
td.num,th.num{text-align:right}
td.empty{color:#94a3b8;text-align:center;padding:18px}
tbody tr:nth-child(even){background:#f4f7fa}
footer.brand{margin-top:26px;border-top:1px solid var(--teal);padding-top:10px;color:#94a3b8;font-size:10.5px;display:flex;justify-content:space-between;flex-wrap:wrap;gap:8px}
@media (max-width:720px){.kpi{grid-template-columns:repeat(2,1fr)}}
@media print{body{padding:0}.report{max-width:none}header.brand{border-color:var(--orange)}th{-webkit-print-color-adjust:exact;print-color-adjust:exact}}
</style></head>
<body><div class="report">
<header class="brand">
<div class="id"><img src="${logoUrl}" alt="Boomerang"></div>
<div class="wordmark"><div class="n">${e(BRAND.name)}</div><div class="s">Télématique &amp; géolocalisation de flotte</div></div>
</header>
<h1 class="title">${e(title)}</h1>
<p class="client">${e(client || "—")}</p>
<p class="period">${e(period || "")}</p>
<p class="genat">Généré le ${e(generatedAt || "")}</p>
${kpiBlock}
<table><thead>${thead}</thead><tbody>${tbody}</tbody></table>
${extraBlock}
<footer class="brand"><span>${e(BRAND.name)} · ${e(client || "—")}</span><span>${e(BRAND.confidential)}</span><span>${e(generatedAt || "")}</span></footer>
</div></body></html>`;
}

// --- CSV machine-compatible (R2) : 1re ligne = en-têtes, aucune métadonnée, séparateur ';', BOM.
// Les cellules doivent déjà être neutralisées (csvSafe) en amont pour conserver la protection R1C.
export function buildCsv({ header, body }) {
  return "\ufeff" + [header.join(";"), ...body.map((r) => r.join(";"))].join("\n");
}

// --- Lignes de métadonnées Excel (avant le tableau) ------------------------------------
// R1C/R2 : les valeurs DYNAMIQUES (titre/client/période/génération) passent par csvSafe pour
// neutraliser toute injection de formule ; la marque statique reste telle quelle.
export function excelMetaRows({ title, client, period, generatedAt }) {
  return [
    [BRAND.name],
    [csvSafe(title)],
    ["Préparé pour :", csvSafe(client)],
    ["Période :", csvSafe(period)],
    ["Généré le :", csvSafe(generatedAt)],
    [],
  ];
}

// --- Logo en dataURL (mise à l'échelle, mise en cache) : évite d'embarquer 454 Ko en PDF --
let _logoPromise = null;
export function getLogoDataUrl(targetW = 220) {
  if (_logoPromise) return _logoPromise;
  _logoPromise = new Promise((resolve) => {
    let settled = false;
    const done = (v) => { if (!settled) { settled = true; resolve(v); } };
    setTimeout(() => done(null), 2500);  // repli : logo optionnel si l'image ne se charge pas (env sans rendu)
    try {
      const img = new Image();
      img.crossOrigin = "anonymous";
      img.onload = () => {
        try {
          const scale = targetW / img.width;
          const c = document.createElement("canvas");
          c.width = targetW; c.height = Math.round(img.height * scale);
          c.getContext("2d").drawImage(img, 0, 0, c.width, c.height);
          done({ dataUrl: c.toDataURL("image/png"), w: c.width, h: c.height });
        } catch { done(null); }
      };
      img.onerror = () => done(null);
      img.src = logoUrl;
    } catch { done(null); }
  });
  return _logoPromise;
}

// --- Textes de page PDF (pure, testable) : en-tête + footer + pagination -----------------
export function pdfPageTexts({ title, client, period, generatedAt, pageNo, totalPages }) {
  return {
    brand: BRAND.name,
    title: String(title),
    metaLine: `Préparé pour : ${client}   |   Période : ${period}`,
    generatedLine: `Généré le : ${generatedAt}`,
    footerLeft: `${BRAND.name} · ${client}`,
    footerConfidential: BRAND.confidential,
    footerCenter: String(generatedAt),
    footerPage: `Page ${pageNo} / ${totalPages}`,
  };
}

// --- En-tête corporate (logo gauche, marque droite, titre/client/période/génération, filet orange) --
function _drawPdfHeader(doc, { W, M, logo, brand, title, client, period, generatedAt, generatedBy, firstPage, headerH, headerHCont }) {
  if (logo && logo.dataUrl) {
    const lw = firstPage ? 160 : 96, lh = Math.min(logo.h * (lw / logo.w), firstPage ? 48 : 26);
    try { doc.addImage(logo.dataUrl, "PNG", M, firstPage ? 24 : 18, lw, lh); } catch { /* logo optionnel */ }
  }
  doc.setFont("helvetica", "bold"); doc.setFontSize(11.5); doc.setTextColor(...BRAND.tealRGB);
  doc.text(brand, W - M, firstPage ? 34 : 30, { align: "right" });     // marque exacte (une fois/page)
  doc.setFont("helvetica", "normal"); doc.setFontSize(7.5); doc.setTextColor(148, 163, 184);
  doc.text("Télématique & géolocalisation de flotte", W - M, firstPage ? 47 : 42, { align: "right" });
  if (firstPage) {
    if (generatedBy) {                                                 // R9 — traçabilité discrète (droite)
      doc.setFont("helvetica", "italic"); doc.setFontSize(8.5); doc.setTextColor(130, 142, 158);
      doc.text(String(generatedBy), W - M, 62, { align: "right" });
    }
    doc.setFont("helvetica", "bolditalic"); doc.setFontSize(11); doc.setTextColor(...BRAND.orangeRGB);
    doc.text(BRAND.tagline, M + 6, 84);                                // slogan sous le logo
    doc.setFont("helvetica", "bold"); doc.setFontSize(21); doc.setTextColor(15, 23, 42);
    doc.text(String(title), M, 116);
    doc.setFont("helvetica", "bold"); doc.setFontSize(12); doc.setTextColor(...BRAND.tealRGB);
    doc.text(String(client || "—"), M, 133);
    doc.setFont("helvetica", "normal"); doc.setFontSize(9); doc.setTextColor(71, 85, 105);
    doc.text(String(period || "").replace(/[→⇒]/g, "—"), M, 146);     // police PDF standard sans glyphe flèche
    doc.setFontSize(8.5); doc.setTextColor(130, 142, 158);
    doc.text(`Généré le ${generatedAt || ""}`, M, 157);
    doc.setDrawColor(...BRAND.orangeRGB); doc.setLineWidth(2.2); doc.line(M, headerH, W - M, headerH);
  } else {
    doc.setFont("helvetica", "bold"); doc.setFontSize(10); doc.setTextColor(15, 23, 42);
    doc.text(String(title), M + 108, 34);
    doc.setDrawColor(...BRAND.orangeRGB); doc.setLineWidth(1.5); doc.line(M, headerHCont, W - M, headerHCont);
  }
}

// --- Titre de section : pastille icône ronde + libellé navy + filet orange (avant chaque bloc) ----
function _drawSectionTitle(doc, { W, M, y, label, iconLabel }) {
  doc.setFillColor(...BRAND.pillBgRGB); doc.circle(M + 9, y - 4, 10, "F");
  _pdfKpiIcon(doc, iconLabel || label, M + 9, y - 4);
  doc.setFont("helvetica", "bold"); doc.setFontSize(13.5); doc.setTextColor(...BRAND.navyRGB);
  doc.text(String(label), M + 26, y);
  const tw = doc.getTextWidth(String(label));
  doc.setDrawColor(...BRAND.orangeRGB); doc.setLineWidth(1.6);
  doc.line(M + 26 + tw + 14, y - 3.5, W - M, y - 3.5);
}

// --- Bandeau contact navy premium (page 1 uniquement) : marque + coordonnées + slogan -------------
function _drawContactBand(doc, { W, H, M }) {
  const bh = 50, by = H - bh;
  doc.setFillColor(...BRAND.navyBandRGB); doc.rect(0, by, W, bh, "F");
  doc.setDrawColor(...BRAND.orangeRGB); doc.setLineWidth(2.4); doc.line(0, by, W, by);
  doc.setFont("helvetica", "bold"); doc.setFontSize(11); doc.setTextColor(255, 255, 255);
  doc.text(BRAND.name, M, by + 21);
  doc.setFont("helvetica", "normal"); doc.setFontSize(7.8); doc.setTextColor(...BRAND.bandSubRGB);
  doc.text(`${BRAND.contact.city}  ·  ${BRAND.contact.phone}`, M, by + 33);
  doc.text(`${BRAND.contact.email}  ·  ${BRAND.contact.web}`, M, by + 43);
  doc.setFont("helvetica", "bolditalic"); doc.setFontSize(13); doc.setTextColor(...BRAND.orangeRGB);
  doc.text(BRAND.tagline, W - M, by + 30, { align: "right" });
}

// --- Cartes KPI premium (pastille icône ronde, label discret, valeur navy mise en avant) --------
function _drawPdfKpis(doc, { M, kpis, perRow, gap, cardW, cardH, top }) {
  kpis.forEach((k, i) => {
    const col = i % perRow, row = Math.floor(i / perRow);
    const x = M + col * (cardW + gap), y = top + row * (cardH + gap);
    doc.setFillColor(...BRAND.cardBgRGB); doc.setDrawColor(...BRAND.cardBorderRGB); doc.setLineWidth(0.6);
    doc.roundedRect(x, y, cardW, cardH, 7, 7, "FD");
    const pillCx = x + 21, pillCy = y + cardH / 2;
    doc.setFillColor(...BRAND.pillBgRGB); doc.circle(pillCx, pillCy, 12, "F");
    _pdfKpiIcon(doc, k[0], pillCx, pillCy);
    const tx = x + 40;
    doc.setFont("helvetica", "normal"); doc.setFontSize(7); doc.setTextColor(...BRAND.grayRGB);
    doc.text(String(k[0]).toUpperCase(), tx, y + 19);
    doc.setFont("helvetica", "bold"); doc.setFontSize(16.5); doc.setTextColor(...BRAND.navyRGB);
    doc.text(String(k[1]), tx, y + 39);
  });
}

// --- Section « Arrêts principaux » (PDF, ≤5 véhicules) : sous le tableau, pagination gérée ----
function _drawStopsSection(doc, { W, H, M, headerHCont, title, items }) {
  let y = (doc.lastAutoTable ? doc.lastAutoTable.finalY : 130) + 28;
  const bottom = H - 64;                                   // réserve le bandeau contact (page 1)
  const contTop = headerHCont + 22;
  const ensure = (need) => { if (y + need > bottom) { doc.addPage(); y = contTop; } };
  ensure(26);
  _drawSectionTitle(doc, { W, M, y, label: String(title), iconLabel: "arrêt" }); y += 18;
  items.forEach((it) => {
    const segs = String(it.text).split(" | ").map((s) => s.trim()).filter(Boolean);
    ensure(14 + segs.length * 12 + 6);
    doc.setFont("helvetica", "bold"); doc.setFontSize(9.5); doc.setTextColor(15, 23, 42);
    doc.text(`${it.vehicle} (${it.plate})`, M, y); y += 13;
    doc.setFontSize(9);
    segs.forEach((seg) => {
      doc.setFont("helvetica", "bold"); doc.setTextColor(...BRAND.orangeRGB); doc.text("•", M + 8, y);
      doc.setFont("helvetica", "normal"); doc.setTextColor(71, 85, 105);
      doc.text(doc.splitTextToSize(seg, W - 2 * M - 20)[0], M + 18, y); y += 12;
    });
    y += 5;
  });
}

// --- Rendu PDF de marque : en-tête corporate, KPI compacts, tableau, footer paginé (Page X / Y) --
export async function renderReportPdf({ jsPDF, autoTable, title, client, period, generatedAt, generatedBy, kpis, header, body, numericIdx, stopsSection, stopsTitle, detailTable, summaryTitle, tableTitle, topBlock }) {
  const landscape = header.length > 6 || (detailTable && detailTable.header && detailTable.header.length > 6);
  const doc = new jsPDF({ orientation: landscape ? "landscape" : "portrait", unit: "pt", format: "a4" });
  const W = doc.internal.pageSize.getWidth();
  const H = doc.internal.pageSize.getHeight();
  const M = 40;
  const logo = await getLogoDataUrl();
  const BAND_H = 56;                 // bandeau contact navy (page 1)

  // Géométrie DÉTERMINISTE calculée AVANT autoTable (placement exact, aucune zone blanche parasite).
  const HEADER_H = 168;             // bloc en-tête page 1 (logo + slogan + titre/client/période, filet orange)
  const HEADER_H_CONT = 52;         // en-tête compact des pages suivantes (filet orange)
  const hasKpis = !!(kpis && kpis.length);
  const perRow = landscape ? 4 : 3;
  const gap = 12, cardH = 52;
  const cardW = (W - 2 * M - (perRow - 1) * gap) / perRow;
  const kpiRows = hasKpis ? Math.ceil(kpis.length / perRow) : 0;
  const kpiSecY = HEADER_H + 28;                    // titre « Synthèse »
  const kpiTop = kpiSecY + 14;
  const kpiBottom = hasKpis ? kpiTop + kpiRows * (cardH + gap) + 2 : HEADER_H + 6;
  // R5 — bloc compact « Sites les plus visités » (présentation seule) intercalé entre KPI et le tableau.
  const hasTop = !!(topBlock && topBlock.length);
  const topSecY = kpiBottom + 24;
  const topRowsTop = topSecY + 12;
  const topLineH = 14;
  const topBottom = hasTop ? topRowsTop + topBlock.length * topLineH + 2 : kpiBottom;
  const tableSecY = topBottom + 24;                 // titre « Détail par véhicule »
  const tableStartY = tableSecY + 12;
  const summaryLabel = summaryTitle || "Synthèse";
  const tableLabel = tableTitle || "Détail par véhicule";

  // Layout robuste : largeurs MIN par type, jamais de wrap caractère par caractère, lignes bornées.
  // Identité (véhicule/immat) + heures/dates = 1 ligne (ellipsis) ; numériques compacts (wrap au mot des en-têtes) ;
  // lieux/adresses/notes = reçoivent l'espace restant (multi-lignes autorisé).
  const _isTime = (h) => /(heure|date|d[ée]but|\bfin\b)/i.test(String(h));
  const _isLoc = (h) => !_isTime(h) && /(lieu|adresse|location|d[ée]part|arriv[ée]e|note|trajet)/i.test(String(h));
  const _colStyles = (hdr, nIdx) => {
    const nset = new Set(nIdx || []);
    const cs = {};
    hdr.forEach((h, i) => {
      if (i === 0) cs[i] = { cellWidth: landscape ? 110 : 88, overflow: "ellipsize", halign: "left" };
      else if (/immat/i.test(String(h))) cs[i] = { cellWidth: landscape ? 70 : 58, overflow: "ellipsize", halign: "left" };
      else if (_isTime(h)) cs[i] = { cellWidth: landscape ? 64 : 56, overflow: "ellipsize", halign: "left" };
      else if (_isLoc(h)) cs[i] = { halign: "left", overflow: "linebreak" };            // largeur auto = espace restant
      else if (nset.has(i)) cs[i] = { cellWidth: landscape ? 54 : 50, overflow: "linebreak", halign: "right" };
      else cs[i] = { cellWidth: landscape ? 60 : 52, overflow: "ellipsize", halign: "left" };
    });
    return cs;
  };
  const columnStyles = _colStyles(header, numericIdx);

  const _headStyles = { fillColor: BRAND.tealRGB, textColor: 255, fontStyle: "bold", halign: "left", valign: "middle", fontSize: landscape ? 8.5 : 9, cellPadding: { top: 7, bottom: 7, left: 7, right: 7 }, lineColor: [255, 255, 255], lineWidth: 0.3 };
  const _bodyStyles = { fontSize: landscape ? 8 : 9, cellPadding: { top: 6, bottom: 6, left: 7, right: 7 }, minCellHeight: 20, valign: "middle", overflow: "linebreak", lineColor: [231, 236, 241], lineWidth: 0.4, textColor: [30, 41, 59] };

  autoTable(doc, {
    head: [header], body,
    startY: hasKpis ? tableStartY : tableStartY,                 // page 1 : sous le titre de section
    margin: { top: HEADER_H_CONT + 12, bottom: BAND_H + 6, left: M, right: M },  // bas : réserve le bandeau contact
    theme: "grid",
    headStyles: _headStyles,
    styles: _bodyStyles,
    alternateRowStyles: { fillColor: BRAND.rowAltRGB },
    columnStyles,
  });

  // Passe finale déterministe : en-tête + KPI (page 1) + footer + pagination sur CHAQUE page.
  // La section « Arrêts principaux » est dessinée AVANT la passe footer pour figer le nb de pages.
  if (stopsSection && stopsSection.length) {
    _drawStopsSection(doc, { W, H, M, headerHCont: HEADER_H_CONT, title: stopsTitle || "Arrêts principaux", items: stopsSection });
  }
  // Second tableau optionnel (« Détail des excès de vitesse ») : rendu AVANT la passe footer.
  if (detailTable && detailTable.header && detailTable.body && detailTable.body.length) {
    let y = (doc.lastAutoTable ? doc.lastAutoTable.finalY : kpiBottom) + 30;
    if (y > H - BAND_H - 80) { doc.addPage(); y = HEADER_H_CONT + 30; }
    _drawSectionTitle(doc, { W, M, y, label: detailTable.title || "Détail", iconLabel: "excès" });
    const dcs = _colStyles(detailTable.header || [], detailTable.numericIdx || []);
    autoTable(doc, {
      head: [detailTable.header], body: detailTable.body, startY: y + 12,
      margin: { top: HEADER_H_CONT + 12, bottom: BAND_H + 6, left: M, right: M }, theme: "grid",
      headStyles: _headStyles,
      styles: _bodyStyles,
      alternateRowStyles: { fillColor: BRAND.rowAltRGB },
      columnStyles: dcs,
    });
  }
  const total = doc.getNumberOfPages();
  for (let p = 1; p <= total; p++) {
    doc.setPage(p);
    const t = pdfPageTexts({ title, client, period, generatedAt, pageNo: p, totalPages: total });
    if (p === 1) _drawCornerArcs(doc, W);
    _drawPdfHeader(doc, { W, M, logo, brand: t.brand, title, client, period, generatedAt, generatedBy,
                          firstPage: p === 1, headerH: HEADER_H, headerHCont: HEADER_H_CONT });
    if (p === 1) {
      if (hasKpis) {
        _drawSectionTitle(doc, { W, M, y: kpiSecY, label: summaryLabel, iconLabel: summaryLabel });
        _drawPdfKpis(doc, { M, kpis, perRow, gap, cardW, cardH, top: kpiTop });
      }
      if (hasTop) {
        _drawSectionTitle(doc, { W, M, y: topSecY, label: "Sites les plus visités", iconLabel: "synthèse" });
        topBlock.forEach((t, i) => {
          const y = topRowsTop + i * topLineH + 4;
          const rank = `${i + 1}. `;
          doc.setFont("helvetica", "bold"); doc.setFontSize(9); doc.setTextColor(...BRAND.navyRGB);
          doc.text(rank, M, y);
          const nameX = M + doc.getTextWidth(rank);
          doc.text(doc.splitTextToSize(String(t.poi), 190)[0], nameX, y);
          doc.setFont("helvetica", "normal"); doc.setTextColor(71, 85, 105);
          doc.text(String(t.detail), M + 250, y);
        });
      }
      _drawSectionTitle(doc, { W, M, y: tableSecY, label: tableLabel, iconLabel: "véhicule" });
      // Bandeau contact navy premium (page 1) + mentions obligatoires overlay (confidentiel + Page X/Y).
      _drawContactBand(doc, { W, H, M });
      doc.setFont("helvetica", "normal"); doc.setFontSize(6.5); doc.setTextColor(...BRAND.bandSubRGB);
      doc.text(t.footerConfidential, W / 2, H - 7, { align: "center" });
      doc.text(t.footerPage, W - M, H - 7, { align: "right" });
    } else {
      // Footer corporate léger (pages suivantes) : marque·client · confidentiel · Page X / Y
      doc.setDrawColor(...BRAND.tealRGB); doc.setLineWidth(0.8); doc.line(M, H - 30, W - M, H - 30);
      doc.setFont("helvetica", "normal"); doc.setFontSize(7.5); doc.setTextColor(148, 163, 184);
      doc.text(t.footerLeft, M, H - 18);
      doc.text(t.footerConfidential, W / 2, H - 18, { align: "center" });
      doc.text(t.footerPage, W - M, H - 18, { align: "right" });
    }
  }
  return doc;
}
